<script setup>
import '@/assets/cloudCounter/css/style.css';
import { ref } from 'vue';
import Layout from '@/components/cloudCounter/Layout.vue';
import CaseBox from '@/components/cloudCounter/CaseBox.vue';
import InfoBox from '@/components/cloudCounter/InfoBox.vue';
import Process from '@/components/cloudCounter/Process.vue';
import { useRouter } from 'vue-router';

const router = useRouter();
const goNextPage = () => {
    router.push({ name:'cloudCounterVideoOperationVerify' });
}

// #region  新要保人姓名
const newApplicantName = ref(null);

// 串接...
newApplicantName.value = {
    boxList: [{
        title: '林中富',
        list: [
            { key: '1066216930-00', value: 'XWO 富邦人壽富利旺終身壽險' },
            { key: '1066216930-00', value: 'XWO 富邦人壽富利旺終身壽險' }
        ]
    }]
};
// #endregion

// #region 新被保險人姓名
const newAssuredName = ref(null);

// 串接...
newAssuredName.value = {
    boxList: [{
        title: '林中富',
        list: [
            { key: '1066216930-00', value: 'XWO 富邦人壽富利旺終身壽險' }
        ]
    }]
};
// #endregion

const infoBoxVisble = ref(false);
const okHandel = () => {

};

</script>

<template>

    <!-- 要保人/受益人姓名變更 -->
    <Layout :header="{ text: '申請內容', backBtn: { visible: true }, closeBtn: { visible: false, to: {} } }">

        <div class="pt-2 pb-6">
            <Process :steps="['服務條款', '查看內容', '視訊驗證', '身份認證',]" :index="1"></Process>
        </div>

        <div class="pb-6">
            <h2 class="pb-3 text-2xl font-bold">
                申請紀錄
            </h2>
            <CaseBox :caseBox="{
        boxList: [
            {
                list: [
                    { key: '申請日期', value: '113/06/15' },
                    { key: '申請項目', value: '要保人或被保險人姓名變更' },
                    { key: '受理案號', value: '114-WBP-0023902' },
                    { key: '視訊時間', value: '113/07/02 10:00~11:00' },
                    { key: '處理狀態', value: '待視訊確認中' }
                ]
            }
        ]
    }" />
        </div>

        <h2 class="pb-3 text-2xl font-bold">
            申請明細
        </h2>

        <div class="pb-6">
            <h3 class="pb-4 text-xl font-bold">
                新要保人姓名
            </h3>
            <p class="pb-4 text-sm">
                同時辦理以下保單號碼之要保人姓名變更
            </p>
            <CaseBox :caseBox="newApplicantName" />
        </div>

        <div class="pb-2">
            <h3 class="pb-4 text-xl font-bold">
                新被保險人姓名
            </h3>
            <p class="pb-4 text-sm">
                同時辦理以下保單號碼之被保險人姓名變更
            </p>
            <CaseBox :caseBox="newAssuredName" />
        </div>

        <div class="text-center">
            <button class="py-3 text-[#EB4751] text-sm" @click="(e) => { infoBoxVisble = true; }">取消預約申請</button>
        </div>

        <template v-slot:bottom>
            <button
                class="w-full pt-5 pb-14 text-center bg-[#0093C1] text-white disabled:bg-[#D7D8DA] disabled:text-[#86878F]"
                @click="goNextPage">開始視訊</button>
        </template>

    </Layout>
    
    <InfoBox v-show="infoBoxVisble" :closeHandel="() => { infoBoxVisble = false; }" title="確定要取消預約申請嗎？" type="confirm"
        :okHandel="okHandel" :buttonText="{ no: '保留預約', yes: '取消預約' }" />

</template>

<style scoped></style>
